module.exports = __webpack_public_path__ + "static/ysdnHeroImage-28c3d0ee781efccab0da3a1f8cb8b48b.mp4";